import * as React from "react";
import { Datagrid, ListContextProvider, useDataProvider } from "react-admin";
import { SourceCoreInfoRequestDetailList } from "./Source";
import { Separator } from "../../../src/Components/Separator";
import CreatedByField from "../../../src/Components/ReferenceFields/CreatedBy/CreatedByField";
import { CustomDateField } from "../../Components/CustomDateField";
import keyBy from "lodash/keyBy";
import { useState } from "react";
import { EnumField } from "../../../src/Components/EnumField";

const CoreInfoRequestListDetail = (props: any) => {
  const provider = useDataProvider();
  const [detailData, setDetailData] = useState([] as any);

  React.useEffect(() => {
    provider
      .getList(SourceCoreInfoRequestDetailList, {
        pagination: { page: 1, perPage: 999 },
        sort: { field: "id", order: "DESC" },
        filter: { coreInfoRequestId__eq: props.id },
      })
      .then(response => {
        if (response.data.length > 0) {
          setDetailData(response.data);
        }
      })
      .catch(error => {});
  }, [props]);

  return (
    <>
      <ListContextProvider
        value={{
          data: keyBy(detailData, "id"),
          ids: detailData.map(({ id }) => id),
          currentSort: { field: "id", order: "ASC" },
        }}
      >
        <Separator />
        <Datagrid>
          <EnumField
            label={"Core Info Request Type"}
            enumName={"CoreInfoRequestReasonTypeEnum"}
            source={"coreInfoRequestReasonId"}
          />
          <CreatedByField label="CREATED BY" link={false} />
          <CustomDateField source="createdDate" label="CREATED  DATE" showTime />
        </Datagrid>
      </ListContextProvider>
    </>
  );
};

export default CoreInfoRequestListDetail;
